module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqBAMAAAA37dRoAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAqUExURUdwTDJu/zBs/zRw/zBv/zJv/zNv/zJu/zBw/zJv/zJu/zNv/zNu/zNv//r57zwAAAANdFJOUwCAQEAi3LdqEO9Qn5Dw43BOAAAA2klEQVQoz2NgIAlwFAoiAykHsGjlXVRwESTIfhcdFABFWTFEZwBFdTFErwNFazFEQQbL0ki0FqsbfDFErwBF2UCMayvB/Fl7QWQCUJQlFsgIYZ8LJG8uaAWSV8HB4wpU6gAi76YwsOQCVUCCcs0eA4YFDIa7ixlYGJhPH0aEcdvFBlBI526BizBpcCjOvRutweB18u5VoYYmSKjzojlsAlbRC0NXNNkYBMzQRBeAmVxooklKIKBGnm3oiTIALMqIJfkC4yUWRfBqAySK3FBEU2Axp46UWYoZSAQAEdPTe69qUb4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/tab/wsc-1.png
// module id = qMNI
// module chunks = 0